<mat-toolbar class="shell-toolbar">
  <mat-toolbar-row class="toolbar-row">
    <button
      mat-icon-button
      type="button"
      class="menu-toggle"
      (click)="drawer.toggle()"
      aria-label="Alternar menu lateral"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <div class="toolbar-brand">
      <img [src]="logoUrl()" alt="Logomarca da empresa" class="brand-logo">
      <div class="brand-divider" aria-hidden="true"></div>
      <span class="brand-title">{{ companyName }}</span>
    </div>

    <span class="toolbar-spacer"></span>

    <div class="toolbar-meta">
      <button
        mat-icon-button
        type="button"
        class="theme-toggle"
        (click)="toggleTheme()"
        [attr.aria-label]="'Alternar para ' + (currentTheme === 'dark' ? 'tema claro' : 'tema escuro')"
        [matTooltip]="currentTheme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'"
      >
        <mat-icon>{{ themeIcon }}</mat-icon>
      </button>

<!--      <div class="theme-indicator" aria-live="polite">-->
<!--        <span>{{ themeLabel }}</span>-->
<!--      </div>-->

      <button
        mat-button
        type="button"
        [matMenuTriggerFor]="userMenu"
        class="profile-trigger"
        aria-label="Abrir menu do usuário"
      >
        <span class="profile-avatar">{{ userInitials }}</span>
        <span class="profile-name">{{ clientName }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>
    </div>

    <mat-menu #userMenu="matMenu" class="profile-menu">
      <div class="menu-profile-summary">
        <span class="menu-avatar">{{ userInitials }}</span>
        <div>
          <strong>{{ clientName }}</strong>
          <span>Cliente</span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="redirect('principal/meus-dados')">
        <mat-icon>person_outline</mat-icon>
        <span>Meus Dados</span>
      </button>
      <button mat-menu-item (click)="redirect('principal/trocar-senha')">
        <mat-icon>lock</mat-icon>
        <span>Trocar Senha</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()" class="logout-action">
        <mat-icon>logout</mat-icon>
        <span>Sair</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>

<mat-drawer-container class="shell-container">
  <mat-drawer
    #drawer
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    class="shell-sidebar"
  >
    <div class="sidebar-panel">
<!--      <div class="sidebar-header">-->
<!--        <img [src]="logoUrl()" alt="Logomarca da empresa" class="sidebar-logo">-->
<!--        <div class="sidebar-title-group">-->
<!--          <span class="sidebar-eyebrow">Área do cliente</span>-->
<!--          <strong>{{ companyName }}</strong>-->
<!--        </div>-->
<!--      </div>-->

      <div class="sidebar-section-label">NAVEGAÇÃO</div>

      <nav class="sidebar-nav" aria-label="Navegação principal">
        <a
          mat-list-item
          class="nav-item"
          [class.active]="isActiveRoute('principal/dashboard')"
          (click)="redirect('principal/dashboard')"
        >
          <span class="nav-item-indicator" aria-hidden="true"></span>
          <mat-icon>home_outlined</mat-icon>
          <span>Início</span>
        </a>

        <a
          mat-list-item
          class="nav-item"
          [class.active]="isActiveRoute('principal/contratos') || isActiveRoute('principal/contrato/')"
          (click)="redirect('principal/contratos')"
        >
          <span class="nav-item-indicator" aria-hidden="true"></span>
          <mat-icon>article</mat-icon>
          <span>Contratos</span>
        </a>

        <a
          mat-list-item
          class="nav-item"
          [class.active]="isActiveRoute('principal/faturas') || isActiveRoute('principal/financeiro') || isActiveRoute('principal/meus-debitos')"
          (click)="redirect('principal/faturas')"
        >
          <span class="nav-item-indicator" aria-hidden="true"></span>
          <mat-icon>receipt_long</mat-icon>
          <span>Cobranças</span>
        </a>

        @if (gatewayStatus.gatewayActive) {
          <a
            mat-list-item
            class="nav-item"
            [class.active]="isActiveRoute('principal/cartoes-credito') || isActiveRoute('principal/cadastro-cartao-credito')"
            (click)="redirect('principal/cartoes-credito')"
          >
            <span class="nav-item-indicator" aria-hidden="true"></span>
            <mat-icon>credit_card</mat-icon>
            <span>Cartões</span>
          </a>
        }
      </nav>

<!--      <aside class="support-card" aria-label="Ajuda e suporte">-->
<!--        <div class="support-icon">-->
<!--          <mat-icon>support_agent</mat-icon>-->
<!--        </div>-->
<!--        <strong>Precisa de ajuda?</strong>-->
<!--        <p>Fale com nosso suporte</p>-->
<!--        <button mat-stroked-button type="button" class="support-action" (click)="openSupport()">-->
<!--          Abrir atendimento-->
<!--        </button>-->
<!--      </aside>-->

<!--      <button-->
<!--        mat-button-->
<!--        type="button"-->
<!--        [matMenuTriggerFor]="userMenu"-->
<!--        class="sidebar-user-card"-->
<!--        aria-label="Abrir menu do usuário"-->
<!--      >-->
<!--        <span class="profile-avatar">{{ userInitials }}</span>-->
<!--        <span class="sidebar-user-info">-->
<!--          <strong>{{ clientName }}</strong>-->
<!--          <span>{{ clientEmail }}</span>-->
<!--        </span>-->
<!--        <mat-icon>expand_more</mat-icon>-->
<!--      </button>-->
    </div>
  </mat-drawer>

  <mat-drawer-content class="shell-content">
    <main class="content-scroll">
      <router-outlet></router-outlet>
    </main>
  </mat-drawer-content>
</mat-drawer-container>
<ngx-spinner></ngx-spinner>
